import { render } from "./ExpenseComponent.vue?vue&type=template&id=79b36cf8&scoped=true"
import script from "./ExpenseComponent.vue?vue&type=script&lang=js"
export * from "./ExpenseComponent.vue?vue&type=script&lang=js"

import "./ExpenseComponent.vue?vue&type=style&index=0&id=79b36cf8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79b36cf8"]])

export default __exports__